export enum Language {
  EN = 'en',
  FR = 'fr',
  ES = 'es',
  NL = 'nl',
  IT = 'it',
  PL = 'pl',
  ZH = 'zh',
  TR = 'tr',
  RU = 'ru',
  DA = 'da',
  JA = 'ja',
  IS = 'is',
  PT = 'pt',
  CZ = 'cz',
  CS = 'cs',
  AR = 'ar',
  EL = 'el',
  DE = 'de',
  KO = 'ko',
  TH = 'th',
  VI = 'vi',
  HI = 'hi',
  UR = 'ur',
  TL = 'tl',
  ID = 'id',
  NO = 'no',
  SV = 'sv',
  LT = 'lt',
}
